import { ICourse } from '@/shared/ICourse';
import { DeleteConfirmationDialog } from '../dashboard/DeleteConfirmationDialog';
import { CourseStorageService } from '../services/CourseStorageService';

export const DeleteCourseDialog = (props: {
  course: ICourse;
  onClose(): void;
  onCourseDeleted? (course: ICourse): void;
}) => {

  const { course } = props;

  const onDelete = async (course: ICourse) => {
    await CourseStorageService.deleteCourse(course.id);
    props.onCourseDeleted?.(course);
  }

  return <DeleteConfirmationDialog
    title='Delete Course'
    description={`The course "${course.CourseTitle}" (${course.folderName}) will be placed to the site recycle bin. Are you sure?`}
    data={course}
    onDelete={onDelete}
    onClose={props.onClose}
  />
}